import { useState } from 'react';
import { toast } from 'sonner';
import { api } from '../api/client';

/**
 * Hook reutilizavel para impersonacao de usuarios.
 * Chama POST /admin/impersonate/:userId e abre nova aba com sessao isolada.
 */
export function useImpersonate() {
  const [impersonating, setImpersonating] = useState<string | null>(null);

  const impersonate = async (userId: string) => {
    setImpersonating(userId);
    // Abrir a nova aba imediatamente no clique (síncrono) para evitar bloqueador de popups
    const newWindow = window.open('about:blank', '_blank');
    try {
      const res = await api.post(`/admin/impersonate/${userId}`);
      const data = res.data;
      const loginUrl = `${window.location.origin}/login?impersonate=${encodeURIComponent(JSON.stringify(data))}`;
      
      if (newWindow) {
        newWindow.location.href = loginUrl;
      }
      toast.success(`Sessão aberta como ${data.user.nome}`);
    } catch (e: any) {
      if (newWindow) newWindow.close();
      toast.error(e?.response?.data?.message || e?.message || 'Erro ao impersonar');
    } finally {
      setImpersonating(null);
    }
  };

  return { impersonate, impersonating };
}
